import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
    en: {
        // Navigation
        'nav-dash': 'Dashboard',
        'nav-tables': 'Table Floor Plan',
        'nav-pos': 'POS Terminal',
        'nav-quick-pos': 'Quick POS (Counter)',
        'nav-franchise-hq': 'Franchise HQ Central',
        'nav-kds': 'Kitchen KDS',
        'nav-inventory': 'Inventory Hub',
        'nav-waiter-sim': 'Captain App',
        'nav-reports': 'Reports',
        'nav-settings': 'Reports',
        'check-updates': 'Check Updates',
        'sign-out': 'Sign Out',

        // Dashboard
        'dash-revenue': "Today's Revenue",
        'dash-orders': 'Orders Completed',
        'dash-occupied': 'Occupied Tables',
        'dash-active-kots': 'Active KOTs',
        'dash-top-items': 'Top Selling Items',
        'dash-hourly-sales': 'Sales Analytics (Hourly)',
        'dash-online-hub': 'Online Integration Hub (Swiggy / Zomato)',
        'dash-no-online': 'No pending online orders.',
        'accept': 'Accept',
        'reject': 'Reject',

        // POS
        'pos-search-placeholder': 'Search menu items (e.g. paneer, naan)...',
        'pos-table-label': 'Table',
        'pos-select-table': 'Select Table',
        'pos-no-active-order': 'No Active Order',
        'pos-waiter-label': 'Waiter',
        'pos-items-added': 'Items Added',
        'pos-subtotal': 'Subtotal',
        'pos-tax': 'CGST + SGST (5%)',
        'pos-discount': 'Discount (Amt)',
        'pos-total': 'Total Bill',
        'pos-cash': 'Cash',
        'pos-upi': 'UPI / PhonePe',
        'pos-card': 'Card',
        'pos-btn-kot': 'KOT Print',
        'pos-btn-settle': 'Settle & Print',
        'pos-veg-tag': 'VEG',
        'pos-nonveg-tag': 'NON-VEG',

        // Categories
        'cat-all': 'All',
        'cat-starters': 'Starters',
        'cat-maincourse': 'Main Course',
        'cat-breads': 'Breads/Roti',
        'cat-rice': 'Rice & Biryani',
        'cat-beverages': 'Beverages',
        'cat-desserts': 'Desserts',

        // KDS
        'kds-title': 'Kitchen Display System',
        'kds-all-stations': 'All Kitchens',
        'kds-veg-station': 'Veg Station',
        'kds-nonveg-station': 'Non-Veg Station',
        'kds-tandoor-station': 'Tandoor Section',
        'kds-wait': 'wait',
        'kds-ready-btn': 'Mark Food Ready',
        'kds-served-btn': 'Food Served',
        'kds-clear': 'Kitchen station is clear. No active orders!',

        // Inventory
        'inv-title': 'Inventory & Recipe Manager',
        'inv-stock-status': 'Raw Material Stock Levels',
        'inv-low-stock-alert': 'Low Stock Alert',
        'inv-low-stock-desc': 'Items highlighted in red require immediate replenishment!',
        'inv-low-stock-prefix': '⚠️ Low Stock Alert: ',
        'inv-low-stock-suffix': ' is running low!',
        
        // Inventory Purchase (Inward)
        'inv-inward-title': 'Inventory Purchase (खरेदी नोंद)',
        'inv-inward-ing': 'Select Raw Ingredient',
        'inv-inward-qty': 'Quantity Purchased',
        'inv-inward-rate': 'Rate per Unit (₹)',
        'inv-inward-vendor': 'Vendor Name',
        'inv-inward-btn': 'Add Stock Inward',
        'inv-inward-ledger': 'Purchase History Ledger',

        // Inventory Wastage (Outward)
        'inv-outward-title': 'Log Manual Outward / Wastage (तूट/नुकसान नोंद)',
        'inv-outward-ing': 'Select Raw Ingredient',
        'inv-outward-qty': 'Quantity Deducted',
        'inv-outward-reason': 'Reason for Outward',
        'inv-reason-wastage': 'Spoilage / Wastage',
        'inv-reason-staff': 'Staff Food',
        'inv-reason-promo': 'Promo / Free Sample',
        'inv-outward-btn': 'Record Outward',
        
        // Reconciliation
        'inv-recon-title': 'Stock Audit & Reconciliation Ledger (साठा ताळेबंद)',
        'inv-col-item': 'Raw Material',
        'inv-col-unit': 'Unit',
        'inv-col-open': 'Opening Stock',
        'inv-col-inward': 'Total Inward (+)',
        'inv-col-sales': 'Sales Outward (-)',
        'inv-col-manual': 'Manual Outward (-)',
        'inv-col-close': 'Closing Stock',
        'inv-col-status': 'Status',

        // Captain Simulator
        'cap-title': 'Captain Mobile Simulator (Waiter PWA)',
        'cap-select-table': 'Select Table to Start Order',
        'cap-table-label': 'Table',
        'cap-items-label': 'Items',
        'cap-cart-total': 'Total',
        'cap-btn-send-kot': 'Send KOT to Kitchen',
        'cap-remarks-placeholder': 'Spicy, no onion, etc...',
        'cap-kot-sent': 'KOT sent to kitchen successfully!',

        // Settings / Reports
        'rep-title': 'SaaS Sales & Transaction Reports',
        'rep-col-id': 'Order ID',
        'rep-col-table': 'Table / Type',
        'rep-col-type': 'Type',
        'rep-col-sub': 'Subtotal',
        'rep-col-disc': 'Discount',
        'rep-col-tax': 'Tax (5%)',
        'rep-col-total': 'Grand Total',
        'rep-col-status': 'Status',
        'rep-status-paid': 'PAID / SETTLED',
        'rep-status-preparing': 'PREPARING',
        'rep-status-ready': 'FOOD READY',

        // Miscellaneous
        'online-mode': 'Online Mode',
        'lang-btn': 'मराठी / हिंदी',
        'close': 'Close',
        'print-receipt': 'Receipt Preview',
        'receipt-subtotal': 'Subtotal:',
        'receipt-tax': 'GST (5%):',
        'receipt-discount': 'Discount:',
        'receipt-total': 'GRAND TOTAL:',
        'receipt-footer': 'THANK YOU / पुन्हा भेटूया!',
        'toast-kot-sent': 'sent to Kitchen KDS!',
        'toast-order-ready': 'marked as Ready for Pickup!',
        'toast-order-served': 'Served!',
        'toast-online-accepted': 'Order accepted! Routed directly to KDS.',
        'toast-online-rejected': 'Order rejected!',
        'toast-inward-success': 'Stock added successfully!',
        'toast-outward-success': 'Manual Outward logged successfully!',
        
        // Dynamic SaaS, Accounting, & Roles
        'nav-accounting': 'Daily Accounting',
        'nav-subscriptions': 'SaaS Subscriptions',
        'nav-owner-settings': 'Menu & Recipe Settings',
        'nav-printer-settings': 'Printer Setup',
        'nav-live-status': 'Live Order Status',
        'nav-token-display': 'Customer Token Display',
        'nav-qr-order': 'QR Ordering & Menu',
        'nav-crm': 'Customer Management',
        'nav-cloud-saas': 'Cloud SaaS Monitor',
        'role-staff': 'Waiters / Cashier',
        'role-manager': 'Hotel Manager',
        'role-owner': 'Hotel Owner',
        'pin-prompt': 'Enter secure Access PIN to switch:',
        'pin-error': 'Invalid PIN entered!',

        // PWA & Updates
        'pwa-title': 'Dinexa POS App',
        'pwa-subtitle': 'Install on desktop/mobile for faster billing & offline support',
        'pwa-badge': 'DESKTOP & MOBILE APP',
        'pwa-feature1-title': 'Super Fast Performance',
        'pwa-feature1-desc': 'Launch in 1 second directly from desktop without opening browser.',
        'pwa-feature2-title': 'Thermal Printer Support',
        'pwa-feature2-desc': 'Instant KOT and receipt printing with thermal printers.',
        'pwa-feature3-title': 'Offline Support',
        'pwa-feature3-desc': 'Smooth billing even with weak or disconnected internet.',
        'pwa-install-btn': '🚀 Install App',
        'pwa-later-btn': 'Later',
        'pwa-installing': 'Installing App...',
        'pwa-complete-title': 'Congratulations! Installation Complete 🎉',
        'pwa-complete-desc': 'Dinexa POS App is ready for use!',
        'pwa-update-title': 'New Update Available! 🚀',
        'pwa-update-badge': 'NEW UPDATE AVAILABLE',
        'pwa-update-desc': 'New system enhancements are live on server. Update now for peak speed & new features.',
        'pwa-update-btn': '⚡ Update Now',
        'pwa-updating': 'Downloading system update files...',
        'pwa-update-done': 'Update Successfully Loaded! 🎉',
        'pwa-reloading': 'Reloading page...',

        // Offline Modal Translations
        'modal-offline-title': '⚠️ Connection Error',
        'modal-offline-subtitle': 'Could not connect to the online cloud server.',
        'modal-offline-question': 'Would you like to save this order in Offline Queue temporarily? (Can be synced online with one click later).',
        'modal-offline-cancel': '❌ Cancel',
        'modal-offline-confirm': '✅ Yes, Save Offline'
    },
    mr: {
        // Navigation
        'nav-dash': 'डॅशबोर्ड',
        'nav-tables': 'टेबल मांडणी',
        'nav-pos': 'POS टर्मिनल',
        'nav-quick-pos': 'झटपट काउंटर POS',
        'nav-franchise-hq': 'फ्रेंचायझी मुख्यालय',
        'nav-kds': 'स्वयंपाकघर KDS',
        'nav-inventory': 'मालसाठा केंद्र',
        'nav-waiter-sim': 'Captain App',
        'nav-reports': 'विक्री अहवाल',
        'nav-settings': 'विक्री अहवाल',
        'check-updates': 'नवीन व्हर्जन अपडेट करा',
        'sign-out': 'बाहेर पडा',

        // Dashboard
        'dash-revenue': 'आजची एकूण कमाई',
        'dash-orders': 'पूर्ण ऑर्डर्स',
        'dash-occupied': 'भरलेले टेबल्स',
        'dash-active-kots': 'सुरू असलेल्या KOTs',
        'dash-top-items': 'सर्वाधिक खपणारे पदार्थ',
        'dash-hourly-sales': 'तासनिहाय विक्री विश्लेषण',
        'dash-online-hub': 'ऑनलाईन ऑर्डर्स हब (Swiggy / Zomato)',
        'dash-no-online': 'कोणतीही प्रलंबित ऑनलाईन ऑर्डर नाही.',
        'accept': 'स्वीकारा',
        'reject': 'नाकारा',

        // POS
        'pos-search-placeholder': 'पदार्थ शोधा (उदा. पनीर, नान)...',
        'pos-table-label': 'टेबल',
        'pos-select-table': 'टेबल निवडा',
        'pos-no-active-order': 'कोणतीही ऑर्डर सुरू नाही',
        'pos-waiter-label': 'वेटर्स',
        'pos-items-added': 'निवडलेले पदार्थ',
        'pos-subtotal': 'एकूण किंमत',
        'pos-tax': 'CGST + SGST (५%)',
        'pos-discount': 'सूट / डिस्काउंट (₹)',
        'pos-total': 'एकूण बिल रक्कम',
        'pos-cash': 'रोख (Cash)',
        'pos-upi': 'UPI / फोनपे',
        'pos-card': 'कार्ड पेमेंट',
        'pos-btn-kot': 'KOT प्रिंट',
        'pos-btn-settle': 'बिल सेटल आणि प्रिंट',
        'pos-veg-tag': 'शाकाहारी',
        'pos-nonveg-tag': 'मांसाहारी',

        // Categories
        'cat-all': 'सर्व',
        'cat-starters': 'स्टार्टर्स',
        'cat-maincourse': 'मुख्य जेवण',
        'cat-breads': 'रोटी / नान',
        'cat-rice': 'भात आणि बिर्याणी',
        'cat-beverages': 'थंड पेये',
        'cat-desserts': 'गोड पदार्थ',

        // KDS
        'kds-title': 'स्वयंपाकघर ऑर्डर्स स्क्रीन (KDS)',
        'kds-all-stations': 'सर्व स्वयंपाकघर',
        'kds-veg-station': 'व्हेज विभाग',
        'kds-nonveg-station': 'नॉन-व्हेज विभाग',
        'kds-tandoor-station': 'तंदूर विभाग',
        'kds-wait': 'वेळ',
        'kds-ready-btn': 'जेवण तयार झाले',
        'kds-served-btn': 'जेवण वाढले',
        'kds-clear': 'सध्या सर्व ऑर्डर्स पूर्ण आहेत!',

        // Inventory
        'inv-title': 'मालसाठा आणि रेसिपी व्यवस्थापक',
        'inv-stock-status': 'कच्चा माल साठा स्थिती',
        'inv-low-stock-alert': 'कमी साठा चेतावणी',
        'inv-low-stock-desc': 'लाल रंगात दर्शविलेला कच्चा माल त्वरित खरेदी करणे आवश्यक आहे!',
        'inv-low-stock-prefix': '⚠️ कमी साठा इशारा: ',
        'inv-low-stock-suffix': ' संपत आले आहे!',

        // Inventory Purchase (Inward)
        'inv-inward-title': 'इन्व्हेंटरी खरेदी नोंद (Stock Inward)',
        'inv-inward-ing': 'कच्चा माल निवडा',
        'inv-inward-qty': 'खरेदी केलेले प्रमाण',
        'inv-inward-rate': 'प्रति युनिट दर (₹)',
        'inv-inward-vendor': 'विक्रेत्याचे नाव (Vendor)',
        'inv-inward-btn': 'साठा जमा करा (Inward)',
        'inv-inward-ledger': 'खरेदी नोंद इतिहास ledger',

        // Inventory Wastage (Outward)
        'inv-outward-title': 'मॅन्युअल वजावट / नुकसान नोंद (Stock Outward)',
        'inv-outward-ing': 'कच्चा माल निवडा',
        'inv-outward-qty': 'वजा करायचे प्रमाण',
        'inv-outward-reason': 'वजावटीचे कारण',
        'inv-reason-wastage': 'नासाडी / खराब माल (Wastage)',
        'inv-reason-staff': 'स्टाफ जेवण (Staff Food)',
        'inv-reason-promo': 'जाहिरात / मोफत नमुना',
        'inv-outward-btn': 'वजावट नोंदवा (Outward)',

        // Reconciliation
        'inv-recon-title': 'साठा मेळ आणि ताळेबंद तक्ता (Reconciliation)',
        'inv-col-item': 'कच्चा माल',
        'inv-col-unit': 'युनिट',
        'inv-col-open': 'सुरुवातीचा साठा',
        'inv-col-inward': 'एकूण खरेदी (+)',
        'inv-col-sales': 'विक्री वापर (-)',
        'inv-col-manual': 'मॅन्युअल वजावट (-)',
        'inv-col-close': 'अखेरचा साठा',
        'inv-col-status': 'स्थिती',

        // Captain Simulator
        'cap-title': 'कॅप्टन मोबाईल ॲप सिम्युलेटर (वेटर्स PWA)',
        'cap-select-table': 'ऑर्डर सुरू करण्यासाठी टेबल निवडा',
        'cap-table-label': 'टेबल',
        'cap-items-label': 'पदार्थ',
        'cap-cart-total': 'एकूण',
        'cap-btn-send-kot': 'केओटी (KOT) किचनला पाठवा',
        'cap-remarks-placeholder': 'तिखट, कांदा नको, इत्यादी...',
        'cap-kot-sent': 'केओटी किचनमध्ये पाठवली गेली आहे!',

        // Settings / Reports
        'rep-title': 'विक्री आणि व्यवहार अहवाल',
        'rep-col-id': 'ऑर्डर आयडी',
        'rep-col-table': 'टेबल / प्रकार',
        'rep-col-type': 'प्रकार',
        'rep-col-sub': 'एकूण मुळ किंमत',
        'rep-col-disc': 'डिस्काउंट',
        'rep-col-tax': 'टॅक्स (५%)',
        'rep-col-total': 'एकूण बिल रक्कम',
        'rep-col-status': 'स्थिती',
        'rep-status-paid': 'बिल भरले / सेटल',
        'rep-status-preparing': 'तयार होत आहे',
        'rep-status-ready': 'पार्सल तयार आहे',

        // Miscellaneous
        'online-mode': 'ऑनलाईन मोड',
        'lang-btn': 'English / हिंदी',
        'close': 'बंद करा',
        'print-receipt': 'बिल पावती प्रिव्ह्यू (कोल्हापुरी ढाबा)',
        'receipt-subtotal': 'एकूण मुळ किंमत:',
        'receipt-tax': 'GST (५%):',
        'receipt-discount': 'डिस्काउंट:',
        'receipt-total': 'एकूण बिल रक्कम:',
        'receipt-footer': 'धन्यवाद / पुन्हा भेटूया!',
        'toast-kot-sent': 'किचन KDS मध्ये पाठवली आहे!',
        'toast-order-ready': 'तयार असल्याचे नोंदवले!',
        'toast-order-served': 'ग्राहकाला वाढले आहे!',
        'toast-online-accepted': 'ऑर्डर स्वीकारली! थेट KDS कडे पाठवली.',
        'toast-online-rejected': 'ऑर्डर नाकारली!',
        'toast-inward-success': 'साठा यशस्वीरीत्या जमा केला!',
        'toast-outward-success': 'मॅन्युअल वजावट यशस्वीरीत्या नोंदवली!',
        
        // Dynamic SaaS, Accounting, & Roles
        'nav-accounting': 'रोजचे जमा-खर्च',
        'nav-subscriptions': 'SaaS सबस्क्रिप्शन',
        'nav-owner-settings': 'मेन्यू आणि रेसिपी सेटिंग्स',
        'nav-printer-settings': 'प्रिंटर जोडणी व टेस्ट',
        'nav-live-status': 'लाईव्ह ऑर्डर ट्रॅकर',
        'nav-token-display': 'ग्राहक टोकन डिस्प्ले',
        'nav-qr-order': 'QR मेनू आणि ऑर्डर',
        'nav-crm': 'ग्राहक व्यवस्थापन (CRM)',
        'nav-cloud-saas': 'क्लाउड SaaS मॉनिटर',
        'role-staff': 'वेटर्स / कॅशियर',
        'role-manager': 'हॉटेल मॅनेजर',
        'role-owner': 'हॉटेल मालक',
        'pin-prompt': 'प्रवेश करण्यासाठी पिन नंबर टाका:',
        'pin-error': 'चुकीचा पिन टाकला आहे!',

        // PWA & Updates
        'pwa-title': 'Dinexa POS App',
        'pwa-subtitle': 'फास्ट बिलिंगसाठी कॉम्प्युटर/मोबाईलवर इंस्टॉल करा',
        'pwa-badge': 'डेस्कटॉप आणि मोबाईल ॲप',
        'pwa-feature1-title': 'सुपर फास्ट परफॉर्मन्स (Fast Launch)',
        'pwa-feature1-desc': 'ब्राऊझर न उघडता थेट डेस्कटॉप वरून १ सेकंदात उघडा.',
        'pwa-feature2-title': 'थर्मल प्रिंटर सपोर्ट (Instant Printing)',
        'pwa-feature2-desc': 'KOT व बिल प्रिंटिंग एकदम वेगाने होते.',
        'pwa-feature3-title': 'ऑफलाईन सपोर्ट (Offline Readability)',
        'pwa-feature3-desc': 'नेट कमी असले तरी बिलिंग सुरळीत चालते.',
        'pwa-install-btn': '🚀 ॲप इंस्टॉल करा (Install)',
        'pwa-later-btn': 'नंतर करा (Later)',
        'pwa-installing': 'ॲप इंस्टॉलेशन सुरू आहे...',
        'pwa-complete-title': 'अभिनंदन! इंस्टॉलेशन पूर्ण झाले 🎉',
        'pwa-complete-desc': 'Dinexa POS App वापरण्यास तयार आहे!',
        'pwa-update-title': 'नवीन अपडेट उपलब्ध आहे! 🚀',
        'pwa-update-badge': 'नवीन अपडेट उपलब्ध',
        'pwa-update-desc': 'सर्व्हरवर Dinexa POS चे नवीन बदल ऑनलाइन अपलोड झाले आहेत. अपडेट करा.',
        'pwa-update-btn': '⚡ नवीन अपडेट लोड करा (Update Now)',
        'pwa-updating': 'नवीन सिस्टीम फाईल्स डाऊनलोड होत आहेत...',
        'pwa-update-done': 'अपडेट यशस्वीरीत्या लोड झाले! 🎉',
        'pwa-reloading': 'पेज रीलोड होत आहे...'
    },
    hi: {
        // Navigation
        'nav-dash': 'डैशबोर्ड',
        'nav-tables': 'टेबल फ्लोर प्लान',
        'nav-pos': 'पीओएस टर्मिनल',
        'nav-quick-pos': 'त्वरित काउंटर POS',
        'nav-franchise-hq': 'फ्रेंचाइजी मुख्यालय',
        'nav-kds': 'रसोई KDS',
        'nav-inventory': 'इन्वेंटरी हब',
        'nav-waiter-sim': 'कैप्टन सिम्युलेटर',
        'nav-reports': 'बिक्री रिपोर्ट',
        'nav-settings': 'बिक्री रिपोर्ट',
        'check-updates': 'नया वर्जन अपडेट करें',
        'sign-out': 'साइन आउट',

        // Dashboard
        'dash-revenue': 'आज की कुल कमाई',
        'dash-orders': 'पूर्ण ऑर्डर्स',
        'dash-occupied': 'भरे हुए टेबल्स',
        'dash-active-kots': 'सक्रिय KOTs',
        'dash-top-items': 'सबसे ज्यादा बिकने वाले उत्पाद',
        'dash-hourly-sales': 'घंटेवार बिक्री विश्लेषण',
        'dash-online-hub': 'ऑनलाइन ऑर्डर एकत्रीकरण (Swiggy / Zomato)',
        'dash-no-online': 'कोई भी लंबित ऑनलाइन ऑर्डर नहीं है।',
        'accept': 'स्वीकार करें',
        'reject': 'अस्वीकार करें',

        // POS
        'pos-search-placeholder': 'आइटम खोजें (जैसे पनीर, नान)...',
        'pos-table-label': 'टेबल',
        'pos-select-table': 'टेबल चुनें',
        'pos-no-active-order': 'कोई सक्रिय ऑर्डर नहीं',
        'pos-waiter-label': 'वेटर',
        'pos-items-added': 'चयनित आइटम',
        'pos-subtotal': 'उपयोग राशि',
        'pos-tax': 'CGST + SGST (5%)',
        'pos-discount': 'छूट / डिस्काउंट (₹)',
        'pos-total': 'कुल बिल राशि',
        'pos-cash': 'नकद (Cash)',
        'pos-upi': 'यूपीआई / फोनपे',
        'pos-card': 'कार्ड पेमेंट',
        'pos-btn-kot': 'KOT प्रिंट',
        'pos-btn-settle': 'बिल सेटल और प्रिंट',
        'pos-veg-tag': 'शाकाहारी',
        'pos-nonveg-tag': 'मांसाहारी',

        // Categories
        'cat-all': 'सभी',
        'cat-starters': 'स्टार्टर्स',
        'cat-maincourse': 'मुख्य भोजन',
        'cat-breads': 'रोटी / नान',
        'cat-rice': 'चावल और बिरयानी',
        'cat-beverages': 'पेय पदार्थ',
        'cat-desserts': 'मिठाई',

        // KDS
        'kds-title': 'रसोई ऑर्डर्स स्क्रीन (KDS)',
        'kds-all-stations': 'सभी रसोई',
        'kds-veg-station': 'वेज स्टेशन',
        'kds-nonveg-station': 'नॉन-वेज स्टेशन',
        'kds-tandoor-station': 'तंदूर विभाग',
        'kds-wait': 'प्रतीक्षा समय',
        'kds-ready-btn': 'भोजन तैयार है',
        'kds-served-btn': 'भोजन परोसा गया',
        'kds-clear': 'रसोई की सभी ऑर्डर्स पूरी हो चुकी हैं!',

        // Inventory
        'inv-title': 'इन्वेंटरी और रेसिपी प्रबंधक',
        'inv-stock-status': 'कच्चा माल स्टॉक स्तर',
        'inv-low-stock-alert': 'कम स्टॉक की चेतावनी',
        'inv-low-stock-desc': 'लाल रंग में चिह्नित कच्चा माल तुरंत खरीदने की आवश्यकता है!',
        'inv-low-stock-prefix': '⚠️ कम स्टॉक चेतावनी: ',
        'inv-low-stock-suffix': ' खत्म होने वाला है!',

        // Inventory Purchase (Inward)
        'inv-inward-title': 'इन्वेंटरी खरीद प्रविष्टि (Stock Inward)',
        'inv-inward-ing': 'कच्चा माल चुनें',
        'inv-inward-qty': 'खरीदी गई मात्रा',
        'inv-inward-rate': 'प्रति इकाई दर (₹)',
        'inv-inward-vendor': 'विक्रेता का नाम (Vendor)',
        'inv-inward-btn': 'स्टॉक जमा करें (Inward)',
        'inv-inward-ledger': 'खरीद इतिहास लेजर',

        // Inventory Wastage (Outward)
        'inv-outward-title': 'मैनुअल कटौती / नुकसान दर्ज करें (Stock Outward)',
        'inv-outward-ing': 'कच्चा माल चुनें',
        'inv-outward-qty': 'कटौती मात्रा',
        'inv-outward-reason': 'कटौती का कारण',
        'inv-reason-wastage': 'खराब सामान (Wastage)',
        'inv-reason-staff': 'स्टाफ भोजन (Staff Food)',
        'inv-reason-promo': 'प्रचार / मुफ्त नमूना',
        'inv-outward-btn': 'कटौती दर्ज करें (Outward)',

        // Reconciliation
        'inv-recon-title': 'स्टॉक ऑडिट और समाधान लेजर (Reconciliation)',
        'inv-col-item': 'कच्चा माल',
        'inv-col-unit': 'इकाई',
        'inv-col-open': 'प्रारंभिक स्टॉक',
        'inv-col-inward': 'कुल खरीद (+)',
        'inv-col-sales': 'बिक्री खपत (-)',
        'inv-col-manual': 'मैनुअल कटौती (-)',
        'inv-col-close': 'अंतिम स्टॉक',
        'inv-col-status': 'स्थिति',

        // Captain Simulator
        'cap-title': 'कैप्टन मोबाइल ऐप सिम्युलेटर (वेटर्स PWA)',
        'cap-select-table': 'ऑर्डर शुरू करने के लिए टेबल चुनें',
        'cap-table-label': 'टेबल',
        'cap-items-label': 'आइटम',
        'cap-cart-total': 'कुल',
        'cap-btn-send-kot': 'केओटी (KOT) रसोई में भेजें',
        'cap-remarks-placeholder': 'तीखा, प्याज नहीं, इत्यादि...',
        'cap-kot-sent': 'केओटी रसोई में भेज दी गई है!',

        // Settings / Reports
        'rep-title': 'बिक्री और लेन-देन रिपोर्ट',
        'rep-col-id': 'ऑर्डर आईडी',
        'rep-col-table': 'टेबल / प्रकार',
        'rep-col-type': 'प्रकार',
        'rep-col-sub': 'उपयोग राशि',
        'rep-col-disc': 'छूट',
        'rep-col-tax': 'टैक्स (5%)',
        'rep-col-total': 'कुल बिल राशि',
        'rep-col-status': 'स्थिति',
        'rep-status-paid': 'बिल भुगतान / सेटल',
        'rep-status-preparing': 'तैयार हो रहा है',
        'rep-status-ready': 'भोजन तैयार है',

        // Miscellaneous
        'online-mode': 'ऑनलाइन मोड',
        'lang-btn': 'English / मराठी',
        'close': 'बंद करें',
        'print-receipt': 'बिल रसीद पूर्वावलोकन (कोल्हापुरी ढाबा)',
        'receipt-subtotal': 'उपयोग राशि:',
        'receipt-tax': 'GST (5%):',
        'receipt-discount': 'छूट:',
        'receipt-total': 'कुल बिल राशि:',
        'receipt-footer': 'धन्यवाद / फिर मिलेंगे!',
        'toast-kot-sent': 'रसोई KDS में भेज दिया गया है!',
        'toast-order-ready': 'तैयार चिह्नित किया गया!',
        'toast-order-served': 'परोसा गया!',
        'toast-online-accepted': 'ऑर्डर स्वीकृत! सीधे KDS में भेजा गया।',
        'toast-online-rejected': 'ऑर्डर अस्वीकृत!',
        'toast-inward-success': 'स्टॉक सफलतापूर्वक जमा किया गया!',
        'toast-outward-success': 'मैनुअल कटौती सफलतापूर्वक दर्ज की गई!',
        
        // Dynamic SaaS, Accounting, & Roles
        'nav-accounting': 'दैनिक लेखा बही',
        'nav-subscriptions': 'SaaS सदस्यताएँ',
        'nav-owner-settings': 'मेनू और रेसिपी सेटिंग्स',
        'nav-printer-settings': 'प्रिंटर सेटिंग्स व टेस्ट',
        'nav-live-status': 'लाइव ऑर्डर ट्रैकर',
        'nav-token-display': 'ग्राहक टोकन डिस्प्ले',
        'nav-qr-order': 'QR मेनू और ऑर्डर',
        'nav-crm': 'ग्राहक प्रबंधन (CRM)',
        'nav-cloud-saas': 'क्लाउड SaaS मॉनिटर',
        'role-staff': 'वेटर / कैशियर',
        'role-manager': 'होटल मैनेजर',
        'role-owner': 'होटल मालिक',
        'pin-prompt': 'प्रवेश के लिए सुरक्षा पिन दर्ज करें:',
        'pin-error': 'गलत सुरक्षा पिन दर्ज किया गया!',

        // PWA & Updates
        'pwa-title': 'Dinexa POS App',
        'pwa-subtitle': 'तेज बिलिंग के लिए डेस्कटॉप/मोबाइल पर इंस्टॉल करें',
        'pwa-badge': 'डेस्कटॉप और मोबाइल ऐप',
        'pwa-feature1-title': 'सुपर फास्ट परफॉर्मेंस (Fast Launch)',
        'pwa-feature1-desc': 'ब्राउजर खोले बिना सीधे डेस्कटॉप से 1 सेकंड में खोलें।',
        'pwa-feature2-title': 'थर्मल प्रिंटर सपोर्ट (Instant Printing)',
        'pwa-feature2-desc': 'KOT और बिल प्रिंटिंग बेहद तेजी से होती है।',
        'pwa-feature3-title': 'ऑफलाइन सपोर्ट (Offline Readability)',
        'pwa-feature3-desc': 'इंटरनेट धीमा होने पर भी बिलिंग सुचारू चलती है।',
        'pwa-install-btn': '🚀 ऐप इंस्टॉल करें (Install)',
        'pwa-later-btn': 'बाद में (Later)',
        'pwa-installing': 'ऐप इंस्टॉलेशन जारी है...',
        'pwa-complete-title': 'बधाई हो! इंस्टॉलेशन पूर्ण हुआ 🎉',
        'pwa-complete-desc': 'Dinexa POS App उपयोग के लिए तैयार है!',
        'pwa-update-title': 'नया अपडेट उपलब्ध है! 🚀',
        'pwa-update-badge': 'नया अपडेट उपलब्ध',
        'pwa-update-desc': 'सर्वर पर Dinexa POS के नए अपडेट लाइव हैं। अपडेट करें।',
        'pwa-update-btn': '⚡ नया अपडेट लोड करें (Update Now)',
        'pwa-updating': 'नई सिस्टम फाइलें डाउनलोड हो रही हैं...',
        'pwa-update-done': 'अपडेट सफलतापूर्वक लोड हुआ! 🎉',
        'pwa-reloading': 'पेज रीलोड हो रहा है...'
    }
};

export const LanguageProvider = ({ children }) => {
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('pos_language') || 'en';
    });

    const switchLanguage = (lang) => {
        setCurrentLanguage(lang);
        localStorage.setItem('pos_language', lang);
    };

    const t = (key) => {
        if (!translations[currentLanguage] || !translations[currentLanguage][key]) {
            return translations['en'][key] || key;
        }
        return translations[currentLanguage][key];
    };

    return (
        <LanguageContext.Provider value={{ currentLanguage, switchLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
